import Component from '@glimmer/component';

export default class PageHeadersSidepanelActionComponent extends Component {
  get selector() {
    return document.querySelector('#sidepanel-actions');
  }
}
